/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Managed collection type enumeration.
 */
export type CollectionKind = typeof CollectionKind[keyof typeof CollectionKind];


export const CollectionKind = {
  category: 'category',
  banner: 'banner',
  subcategory: 'subcategory',
  editorial: 'editorial',
  ranking: 'ranking',
  author: 'author',
  lector: 'lector',
  publisher: 'publisher',
  series: 'series',
  tag: 'tag',
  emotion: 'emotion',
  personal: 'personal',
} as const;
